document.addEventListener("DOMContentLoaded", () => {
  const accordionTriggers = document.querySelectorAll(".js-footer-accordion");

  accordionTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      if (window.innerWidth > 768) return;
      const block = e.currentTarget.closest(".site-footer__block");
      const isExpanded = trigger.getAttribute("aria-expanded") === "true";
      block.classList.toggle("site-footer__block--active");
      trigger.setAttribute("aria-expanded", !isExpanded);
    });
  });
});
